"use strict";

//language=HTML,js
import {Modal} from 'bootstrap';
import {v4 as uuid} from 'uuid';

const fetchLinkEvent = (e) => {
    if (e.button !== 0 && e.button !== 1) {
        return;
    }
    const link = e.target.closest('[data-fetch="link"]');
    if (link) {
        const url = link.href || link.dataset.url;
        if (!url) {
            return;
        }
        e.preventDefault();
        if (e.ctrlKey || e.button === 1 || link.getAttribute('target') === '_blank') {
            window.open(url);
        } else {
            window.location.href = url;
        }
    }
}

document.body.addEventListener('click', fetchLinkEvent);
document.body.addEventListener('auxclick', fetchLinkEvent);

const fetchModalEvent = e => {
    if (e.button !== 0 && e.button !== 1) {
        return;
    }
    const link = e.target.closest('[data-fetch="modal"]');
    if (!link) {
        return;
    }
    const url = link.getAttribute('href') ?? link.dataset.url;
    if (!url) {
        return;
    }
    e.preventDefault();

    if (e.type === 'mousedown' || (e.type === 'mouseup' && e.button === 0)) {
        return;
    }

    if (e.ctrlKey || e.button === 1) {
        window.open(url);
    } else {
        e.preventDefault();

        const options = {
            size: link.dataset.fetchModalSize ?? link.dataset.modalSize ?? link.dataset.fetchSize ?? null,
            class: link.dataset.fetchModalClass ?? null,
            backdrop: link.dataset.fetchModalBackdrop ?? null,
        };

        icing.modal(url, options);
    }
};

document.addEventListener('click', fetchModalEvent);
document.addEventListener('mousedown', fetchModalEvent);
document.addEventListener('mouseup', fetchModalEvent);



